/**
 * Root Reducer
 */
import { combineReducers } from 'redux';

// Import Reducers
import app from './modules/App/AppReducer';
import intl from './modules/Intl/IntlReducer';
import error from './modules/Error/ErrorReducer';
import config from './modules/Config/ConfigReducer';
import currency from './modules/Currency/CurrencyReducer';

import addresses from './modules/Address/AddressReducer';
import affiliations from './modules/Affiliation/AffiliationReducer';
import cart from './modules/Cart/CartReducer';
import conversations from './modules/Conversation/ConversationReducer';
import orders from './modules/Order/OrderReducer';
import processes from './modules/Process/ProcessReducer';
import products from './modules/Product/ProductReducer';
import shippings from './modules/Shipping/ShippingReducer';
import tasks from './modules/Task/TaskReducer';
import users from './modules/User/UserReducer';
import vatRates from './modules/Vat/VatReducer';
import vouchers from './modules/Voucher/VoucherReducer';

// Combine all reducers into one root reducer
export default combineReducers({
    addresses,
	affiliations,
    app,
	cart,
    config,
    conversations,
    currency,
    error,
    intl,
	orders,
    processes,
    products,
	shippings,
	tasks,
    users,
	vatRates,
	vouchers,
});
